export default __webpack_public_path__ + "static/media/illus-niveau1-partenaire.886e4c7e.svg";